export default {
  getMap (m) {
    return m
  },
  map: ''
}



// WEBPACK FOOTER //
// ./src/map/getMap.js